import { render } from "./MonitorMessage.vue?vue&type=template&id=25f266bc"
import script from "./MonitorMessage.vue?vue&type=script&lang=js"
export * from "./MonitorMessage.vue?vue&type=script&lang=js"

import "./MonitorMessage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__